module.exports = __webpack_public_path__ + "img/23.dcf717d3.png";